import React from 'react';
import TextField from 'material-ui/TextField';
import styles from './styles';

const renderTextField = ({
    input,
    label,
    meta: { touched, error },
    ...custom
  }) => (
    <TextField
      label={label}
      error={touched && error?true:false}
      helperText={touched && error}
      {...input}
      {...custom}
    />
)

export default renderTextField;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/renderTextField.js